import {
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
} from "@mui/material";
import NavigateBefore from "@mui/icons-material/NavigateBefore";
import NavigateNext from "@mui/icons-material/NavigateNext";

function BedroomFilters({
  mode = "board",
  selectedDate,
  campuses,
  houses = [],
  genders,
  ages,
  nationalities = [],
  selectedCampus,
  selectedHouse,
  selectedGender,
  selectedAge,
  selectedNationality,
  nameSearch,
  roomNameSearch,
  roomFilterMode,
  onDateChange,
  onShiftDate,
  onCampusChange,
  onHouseChange,
  onGenderChange,
  onAgeChange,
  onNationalityChange,
  onNameSearchChange,
  onRoomSearchChange,
  onRoomFilterModeChange,
}) {
  return (
    <Stack
      direction="row"
      spacing={2}
      alignItems="center"
      justifyContent="center"
      flexWrap="wrap"
      sx={{ my: 2 }}
    >
      <IconButton onClick={() => onShiftDate(-1)} aria-label="Previous Day">
        <NavigateBefore />
      </IconButton>

      <TextField
        type="date"
        size="small"
        value={selectedDate.format("YYYY-MM-DD")}
        onChange={(e) => onDateChange(e.target.value)}
      />

      <IconButton onClick={() => onShiftDate(1)} aria-label="Next Day">
        <NavigateNext />
      </IconButton>

      <FormControl sx={{ minWidth: 160 }} size="small">
        <InputLabel>Campus</InputLabel>
        <Select
          value={selectedCampus}
          label="Campus"
          onChange={(e) => onCampusChange(e.target.value)}
          sx={{
              minWidth: 100,
              "& .MuiOutlinedInput-root": { height: 40 },
             }}
        >
          <MenuItem value="" disabled>Select a campus</MenuItem>
            {campuses.map((campus) => (
              <MenuItem key={campus.id} value={String(campus.id)}>
                {campus.name}
              </MenuItem>
            ))}
        </Select>
      </FormControl>

      <FormControl sx={{ minWidth: 160 }} size="small">
        <InputLabel>House</InputLabel>
        <Select
          value={selectedHouse}
          label="House"
          onChange={(e) => onHouseChange(e.target.value)}
          sx={{
            minWidth: 100,
            "& .MuiOutlinedInput-root": { height: 40 },
          }}
        >
          <MenuItem value="">All Houses</MenuItem>
          {houses.map((house) => (
            <MenuItem key={house} value={house}>
              {house}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl sx={{ minWidth: 160 }} size="small">
        <InputLabel>Gender</InputLabel>
        <Select
          value={selectedGender}
          label="Gender"
          onChange={(e) => onGenderChange(e.target.value)}
          sx={{
              minWidth: 120,
              "& .MuiOutlinedInput-root": { height: 40 },
             }}
        >
          <MenuItem value="">All Genders</MenuItem>
          {genders.map((gender) => (
            <MenuItem key={gender} value={gender}>
              {gender}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl sx={{ minWidth: 120 }} size="small">
        <InputLabel>Age</InputLabel>
        <Select
          value={selectedAge}
          label="Age"
          onChange={(e) => onAgeChange(e.target.value)}
          sx={{
              minWidth: 120,
              "& .MuiOutlinedInput-root": { height: 40 },
             }}
        >
          <MenuItem value="">All Ages</MenuItem>
          {ages.map((age) => (
            <MenuItem key={age} value={age}>
              {age}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {mode === "table" && (
        <FormControl sx={{ minWidth: 160 }} size="small">
          <InputLabel>Nationality</InputLabel>
          <Select
            value={selectedNationality}
            label="Nationality"
            onChange={(e) => onNationalityChange(e.target.value)}
            sx={{
              minWidth: 100,
              "& .MuiOutlinedInput-root": { height: 40 },
             }}
          >
            <MenuItem value="">All Nationalities</MenuItem>
            {nationalities.map((nationality) => (
              <MenuItem key={nationality} value={nationality}>
                {nationality}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}

      {mode === "table" && (
        <FormControl sx={{ minWidth: 140 }} size="small">
          <InputLabel>Room Status</InputLabel>
          <Select
            value={roomFilterMode}
            label="Room Status"
            onChange={(e) => onRoomFilterModeChange(e.target.value)}
            sx={{
              minWidth: 100,
              "& .MuiOutlinedInput-root": { height: 40 },
             }}
          >
            <MenuItem value="all">All</MenuItem>
            <MenuItem value="assigned">Assigned</MenuItem>
            <MenuItem value="unassigned">Unassigned</MenuItem>
          </Select>
        </FormControl>
      )}

      <TextField
        size="small"
        label="Search Name"
        value={nameSearch}
        onChange={(e) => onNameSearchChange(e.target.value)}
        sx={{
              minWidth: 100,
              "& .MuiOutlinedInput-root": { height: 40 },
             }}
      />
      <TextField
        size="small"
        label="Search Room"
        value={roomNameSearch}
        onChange={(e) => onRoomSearchChange(e.target.value)}
        sx={{
              minWidth: 100,
              "& .MuiOutlinedInput-root": { height: 40 },
             }}
      />
    </Stack>
  );
}

export default BedroomFilters;